module.exports = {"310105001":"华阳路街道","310105002":"江苏路街道","310105004":"新华路街道","310105005":"周家桥街道","310105006":"天山路街道","310105008":"仙霞新村街道","310105009":"虹桥街道","310105010":"程家桥街道","310105011":"北新泾街道","310105102":"新泾镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310105.json
// module id = 909
// module chunks = 0